export default __webpack_public_path__ + "images/36458209cfadaf8150296a67785f24ad-Eventbrite_NYE_HomepageC_1067x312.webp";